import { BASE_URL } from '@/constants'
import axiosInstance from 'axios'
import { eventBus } from './plugins/ugarit';
import store from './store';
import router from './router';
import i18n from './i18n/i18n';

const messageHandler = (message) => {
	let tempMessage = message;
	if (/[{}]/.test(message)) {
		const start = tempMessage.indexOf('{');
		const end = tempMessage.indexOf('}');
		const itemId = tempMessage.slice(start + 1, end);
		tempMessage =
			tempMessage.replace(`{${itemId}}`, store.getters['items/getItemById'](itemId)?.name ?? '');
	}
	return tempMessage;
}

const axios = axiosInstance.create({
	baseURL: BASE_URL
});

axios.interceptors.response.use(
	response => {
		if (response.config.params) {
			let page, perPage;
			if (response.config.params instanceof URLSearchParams) {
				page = response.config.params.get('page');
				perPage = response.config.params.get('perPage');
			} else {
				page = response.config.params.page;
				perPage = response.config.params.perPage;
			}
			if (page && perPage) {
				return {
					data: response.data,
					total: +response.headers['x-pagination-total-count'],
					headers: response.headers
				}
			}
		}
		return response.data;
	},
	error => {
		if (!error.response || !window.navigator.onLine) {
			eventBus.$emit('show-snackbar', i18n.t('messages.check-your-connection'), 'warning')
		}
		if (router.currentRoute.name !== 'login' && error.response && error.response.status === 401) {
			store.dispatch('auth/logout');
			router.replace({ name: 'login' });
		}
		if (error.response.status === 423) {
			router.replace({ name: 'home' });
		}
		eventBus.$emit(
			'show-snackbar',
			messageHandler(
				error.response.data.title ||
				error.response.data.message || 
				error.response.data
			), 
			'error'
		);
		return Promise.reject(error);
	},
)

export default axios;